import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-chest.mjs";
import { render } from "lit-html";
import { Chest, Chests } from "../../../models/Chests.ts";
import { linkify, unlinkify, loadYouTubeAPI } from "../../global.ts";
import { Speech } from "../../../models/Speech.ts";
import { HbB } from "../../hb-main/hb-b/hb-b.ts";
import { HbMain } from "../../hb-main/hb-main.ts";
import { Chest as Manager } from "../../../managers/Chest.ts";
import { Me } from "../../../managers/Me.ts";
import { Stamps } from "../../../models/Stamps.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import { Carousel } from "flowbite";
import type {
    CarouselItem,
    CarouselOptions,
    CarouselInterface
} from "flowbite";

//TODO: later maybe show full screen ??

export class HbChest extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private stamps = new Stamps();
    private me = new Me();
    private speech = new Speech();
    private chests = new Chests();
    private modal: ModalInterface;
    private carousel: CarouselInterface | null = null;
    private main = document.querySelector("hb-main") as HbMain;
    private source:
        | "none"
        | "minting"
        | "mining"
        | "mint"
        | "mine"
        | "mints"
        | "mines" = "none";

    private chest: HTMLElement;
    private name: HTMLHeadingElement;
    private previousBtn: HTMLButtonElement;
    private nextBtn: HTMLButtonElement;
    private slider: HTMLElement;
    private close: HTMLButtonElement;

    // step 1
    private proof: HTMLElement;
    private b: HbB;
    private nearby: HTMLElement;
    private location: HTMLElement;

    // step 2
    private coverVideo: HTMLVideoElement;
    private coverMessage: HTMLParagraphElement;
    private coverBtn: HTMLButtonElement;

    // step 3
    private hasDiamond = false;

    // step 4
    private youtube: YT.Player | null = null;
    //private ad: HTMLElement;

    // step 5

    private chestName = ""; // not used
    private chestFrom = "";
    private chestTo = "";

    constructor() {
        super();
        render(template(), this);

        this.chest = this.querySelector("#hb-chest")!;
        this.name = this.querySelector("#hb-chest-name")!;
        this.slider = this.querySelector("#hb-chest-carousel")!;
        this.previousBtn = this.querySelector("#hb-chest-carousel-previous")!;
        this.nextBtn = this.querySelector("#hb-chest-carousel-next")!;
        this.close = this.querySelector("#hb-chest-close")!;

        this.b = this.querySelector("hb-b")!;
        this.proof = this.querySelector("#hb-chest-proof")!;
        this.nearby = this.querySelector("#hb-chest-nearby")!;
        this.location = this.querySelector("#hb-chest-location")!;

        this.coverVideo = this.querySelector("#hb-chest-cover-video")!;
        this.coverMessage = this.querySelector("#hb-chest-cover-message")!;
        this.coverBtn = this.querySelector("#hb-chest-cover-button")!;

        ///this.ad = this.querySelector("#hb-chest-ad")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: false,
            onHide: () => {
                //this.carousel?.pause();
                // pause both videos
                this.coverVideo.pause();
                this.pauseAd();
            },
            onShow: () => {
                //this.carousel?.slideTo(0);
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-chest",
            override: true
        };

        this.modal = new Modal(this.chest, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //loadYouTubeAPI();

        this.close.addEventListener("click", () => {
            this.hide();
            const url = new URL(window.location.href);
            switch (this.source) {
                case "none": // map
                    window.location.hash = "#";
                    break;
                case "minting": // step 3
                    window.location.hash = "#/mint/jewel";
                    break;
                case "mining": // after general public scans b-stamp
                    window.location.hash = this.heartbank.user
                        ? "#/vault/mine"
                        : "#/onboard/start";
                    break;
                case "mint": // after minting
                    window.location.hash = "#/mint/chest";
                    break;
                case "mine": // after mining
                    window.location.hash = "#/vault/mine";
                    //window.location.hash = "#/mine";
                    break;
                case "mints": // for cloud
                    url.hash = "#/vault/mint";
                    history.replaceState(null, "", url.toString());
                    this.main.backVault("mint");
                    //window.location.hash = "#/vault/mint";
                    break;
                case "mines": // for cloud
                    url.hash = "#/vault/mine";
                    history.replaceState(null, "", url.toString());
                    this.main.backVault("mine");
                    //window.location.hash = "#/vault/mine";
                    break;
            }
        });

        // set event listeners for prev and next buttons
        this.previousBtn.addEventListener("click", () => {
            this.carousel?.prev();
            this.processStep();
        });
        this.nextBtn.addEventListener("click", () => {
            this.carousel?.next();
            this.processStep();
        });

        // step 2
        this.coverMessage.addEventListener("click", () => {
            if (this.coverVideo.paused) {
                this.coverVideo.play();
            } else {
                this.coverVideo.pause();
            }
        });

        this.coverBtn.addEventListener("click", () => {
            this.coverVideo.play();
        });

        // step 5
        const hbBtn = this.querySelector("#hb-chest-carousel-5")!
            .firstElementChild as HTMLButtonElement;
        hbBtn.addEventListener("click", async () => {
            const count = await this.chests.count();
            window.location.hash =
                count === 0
                    ? this.heartbank.user
                        ? "#/onboard/training-2"
                        : "#/onboard/training-1"
                    : "#/mint/ship";
        });

        // this.heartbank.addAuthStateListener((user) => {
        //     if (user) {
        //         this.b.render = "avatar";
        //         this.b.renderAvatar(user);
        //     } else this.b.render = "none";
        // });
    }

    private async processStep() {
        const activeItem = this.carousel?.getActiveItem();
        //console.log(this.hasDiamond, activeItem?.position);

        switch (activeItem?.position) {
            case 0:
                this.name.textContent = "From: " + this.chestFrom;
                break;
            case 1:
                this.name.textContent = "To: " + this.chestTo;
                break;
            case 2:
                this.name.textContent = "Coming Soon";
                break;
            case 3:
                this.name.textContent = "Pearl Ad"; //Free for Kiitti
                break;
            default:
                this.name.textContent = this.chestName;
        }

        if (activeItem?.position === 1) {
            // play jewel
            this.coverVideo.play(); // maybe dont autoplay ? add to advanced features ?
            // pause ad
            this.pauseAd();
        } else if (
            (activeItem?.position === 3 && !this.hasDiamond) ||
            (activeItem?.position === 4 && this.hasDiamond)
        ) {
            // play ad
            this.playAd();
            // pause jewel
            this.coverVideo.pause();
        } else {
            // pause both videos
            this.coverVideo.pause();
            this.pauseAd();
        }
    }

    // bc weird bug
    private playAd() {
        if (this.youtube?.playVideo) this.youtube.playVideo();
    }

    // bc weird bug
    private pauseAd() {
        if (this.youtube?.pauseVideo) this.youtube?.pauseVideo();
    }

    // TODO: when doing sidekick AI
    private isNearby(chest: Chest): boolean {
        if (chest.users?.includes(this.heartbank.user?.uid || "")) {
            const recipient: any = chest.recipients?.find((recipient: any) => {
                return !!this.me.getToAddressType2(
                    recipient.p,
                    this.heartbank.user?.uid || null
                );
            });
            return !!recipient.n;
        }
        return false;
    }

    private getFlag(data: any) {
        switch (data.l.c) {
            case "US":
                return "🇺🇸";
            default:
                return "🇺🇸";
        }
    }

    // TODO: later do query string instead? ?source=
    async show(id: string, source: string) {
        this.main.showSpinner();
        this.chest.classList.add("pointer-events-none");
        this.modal.show();

        const chest = (await this.chests.get(id))!;
        const data = JSON.parse(decodeURIComponent(chest.data.split("/")[1]));
        this.source =
            (source as "none" | "mint" | "mine" | "mints" | "mines") || "none";
        const manager = new Manager(chest, data);

        // title
        const stamps = await this.stamps.stampCountTotal(chest.id);
        this.chestName = chest.name;
        this.chestFrom = await this.me.getName(data.f.p);
        this.chestTo = await this.me.getNames(data.t);
        this.name.textContent = "From: " + this.chestFrom;
        const stamp = this.querySelector("#hb-chest-stamp") as SVGElement;
        const cloud = this.querySelector("#hb-chest-cloud") as SVGElement;
        const code = this.querySelector("#hb-chest-code") as SVGElement;
        const crystal = this.querySelector("#hb-chest-crystal") as SVGElement;
        code.classList.toggle("hidden", data.b.v !== 1);
        crystal.classList.toggle("hidden", data.b.v !== 2);
        if (stamps) {
            stamp.classList.remove("hidden");
            cloud.classList.add("hidden");
            stamp.onclick = () =>
                alert(
                    `${stamps} Silver B-Stamp${
                        stamps === 1 ? "" : "s"
                    } in total ${
                        stamps === 1 ? "has" : "have"
                    } been linked to this Silver B-Chest.`
                );
        } else {
            stamp.classList.add("hidden");
            cloud.classList.toggle("hidden", data.b.v !== 0);
        }

        // step 1
        const pin = this.nearby.firstElementChild as SVGElement;
        const nearby = this.nearby.lastElementChild as HTMLSpanElement;
        pin.style.fill = data.l.h ? "gray" : "orange";
        nearby.textContent = this.isNearby(chest) ? "Nearby" : "Not Nearby";

        const location = await manager.getLocation();
        const flag = this.location.firstElementChild as HTMLSpanElement;
        const place = this.location.lastElementChild as HTMLSpanElement;
        flag.textContent = this.getFlag(data);
        flag.classList.toggle("opacity-50", !!data.l.h);
        place.textContent = data.l.n;
        this.location.onclick = () =>
            window.open(
                `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`,
                "_blank"
            );

        const icon = this.proof.firstElementChild as HTMLSpanElement;
        const proof = this.proof.lastElementChild as HTMLSpanElement;
        if (data.b.s) {
            this.proof.classList.add(
                "bg-green-100",
                "text-green-800",
                "dark:bg-green-900",
                "dark:text-green-300"
            );
            this.proof.classList.remove(
                "bg-gray-100",
                "text-gray-800",
                "dark:bg-gray-800",
                "dark:text-gray-400"
            );
            icon.classList.add("bg-green-500");
            icon.classList.remove("bg-gray-500");
            proof.textContent = "Humanity Verified";
        } else {
            this.proof.classList.add(
                "bg-gray-100",
                "text-gray-800",
                "dark:bg-gray-800",
                "dark:text-gray-400"
            );
            this.proof.classList.remove(
                "bg-green-100",
                "text-green-800",
                "dark:bg-green-900",
                "dark:text-green-300"
            );
            icon.classList.add("bg-gray-500");
            icon.classList.remove("bg-green-500");
            proof.textContent = "Humanity Not Verified";
        }

        this.b.karat = "silver";
        this.b.rainbow = false;
        this.b.heartbeat = !!data.b.s;
        this.b.render = "avatar";
        this.b.renderAvatar(data.f.p);

        // step 2
        const message = await manager.getMessage();
        this.coverVideo.src = chest.coverVideo;
        this.coverVideo.poster = chest.coverPoster;
        this.coverMessage.innerHTML = message
            ? linkify(message)
            : "Private Message";
        this.coverMessage.classList.remove("hidden");

        this.coverVideo.onplay = () => {
            //this.coverMessage.textContent = chest.message;
            //this.coverMessage.classList.remove("hidden");
            //this.coverBtn.classList.add("hidden");

            this.speech.speak(
                message ? unlinkify(message) : "Private Message",
                () => {
                    this.coverVideo.pause();
                }
            );
        };

        this.coverVideo.onpause = () => {
            this.speech.pause();
            //this.coverBtn.classList.remove("hidden");
        };

        // step 3
        this.hasDiamond = !!data.d;

        const diamondItem = this.querySelector(
            "#hb-chest-carousel-3"
        ) as HTMLDivElement;
        if (this.hasDiamond) diamondItem.setAttribute("data-carousel-item", "");
        else diamondItem.removeAttribute("data-carousel-item");

        const diamondSlide = this.querySelector(
            "#hb-chest-slide-3"
        ) as HTMLButtonElement;
        diamondSlide.classList.toggle("hidden", !this.hasDiamond);

        // step 4
        await loadYouTubeAPI(); // will only load one time
        this.youtube = await this.initializeYouTube(); // will only load one time

        // step 5
        this.initCarousel();
        //this.modal.show();
        this.main.hideSpinner();
        this.chest.classList.remove("pointer-events-none");

        //stats
        if (data.b.v === 0 && this.heartbank.user?.uid !== chest.uid)
            this.chests.incrementViews(chest.id);
    }

    hide() {
        this.modal.hide();
    }

    private initCarousel() {
        const items: CarouselItem[] = this.hasDiamond
            ? [
                  {
                      position: 0,
                      el: this.querySelector("#hb-chest-carousel-1")!
                  },
                  {
                      position: 1,
                      el: this.querySelector("#hb-chest-carousel-2")!
                  },
                  {
                      position: 2,
                      el: this.querySelector("#hb-chest-carousel-3")!
                  },
                  {
                      position: 3,
                      el: this.querySelector("#hb-chest-carousel-4")!
                  },
                  {
                      position: 4,
                      el: this.querySelector("#hb-chest-carousel-5")!
                  }
              ]
            : [
                  {
                      position: 0,
                      el: this.querySelector("#hb-chest-carousel-1")!
                  },
                  {
                      position: 1,
                      el: this.querySelector("#hb-chest-carousel-2")!
                  },
                  {
                      position: 2,
                      el: this.querySelector("#hb-chest-carousel-4")!
                  },
                  {
                      position: 3,
                      el: this.querySelector("#hb-chest-carousel-5")!
                  }
              ];

        // object options with default values
        const options: CarouselOptions = {
            defaultPosition: 0,
            interval: 3000,

            indicators: {
                activeClasses: "bg-white dark:bg-gray-800",
                inactiveClasses:
                    "bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800",
                items: this.hasDiamond
                    ? [
                          {
                              position: 0,
                              el: this.querySelector("#hb-chest-slide-1")!
                          },
                          {
                              position: 1,
                              el: this.querySelector("#hb-chest-slide-2")!
                          },
                          {
                              position: 2,
                              el: this.querySelector("#hb-chest-slide-3")!
                          },
                          {
                              position: 3,
                              el: this.querySelector("#hb-chest-slide-4")!
                          },
                          {
                              position: 4,
                              el: this.querySelector("#hb-chest-slide-5")!
                          }
                      ]
                    : [
                          {
                              position: 0,
                              el: this.querySelector("#hb-chest-slide-1")!
                          },
                          {
                              position: 1,
                              el: this.querySelector("#hb-chest-slide-2")!
                          },
                          {
                              position: 2,
                              el: this.querySelector("#hb-chest-slide-4")!
                          },
                          {
                              position: 3,
                              el: this.querySelector("#hb-chest-slide-5")!
                          }
                      ]
            },

            // callback functions: cannot detect current active item
            onNext: () => {},
            onPrev: () => {},
            onChange: () => {}
        };

        const instanceOptions: InstanceOptions = {
            id: "hb-chest-carousel",
            override: true
        };

        if (this.carousel) {
            // for (let i = 0; i < this.carousel.getActiveItem().position; i++) {
            //     this.carousel.prev();
            // }
            this.carousel.slideTo(0);
            this.carousel.destroyAndRemoveInstance();
        }

        this.carousel = new Carousel(
            this.slider,
            items,
            options,
            instanceOptions
        );

        //this.carousel.cycle();
    }

    // Initialize YouTube player and wait for it to be ready
    private initializeYouTube(): Promise<YT.Player> {
        return new Promise((resolve, reject) => {
            // If a player instance already exists, destroy it first to avoid conflicts
            if (this.youtube) {
                resolve(this.youtube);
                // causes weird bug:
                //this.youtube.destroy();
                //this.youtube = null;
            } else {
                new YT.Player("hb-chest-ad", {
                    host: "https://www.youtube.com",
                    videoId: "sRE8Rx-rOKY",
                    playerVars: {
                        controls: 0,
                        autoplay: 0,
                        mute: 0,
                        modestbranding: 1,
                        rel: 0,
                        showinfo: 0,
                        playsinline: 1,
                        origin: window.location.origin
                    },
                    events: {
                        onReady: (event: YT.PlayerEvent) => {
                            // The player is now fully functional.
                            // The `event.target` is the player instance.
                            //console.log("YouTube Player is ready");
                            // Resolve the promise to signal that initialization is complete.
                            resolve(event.target);
                        },
                        onStateChange: (event: YT.OnStateChangeEvent) => {
                            switch (event.data) {
                                case YT.PlayerState.UNSTARTED: // -1 player initialized
                                    break;
                                case YT.PlayerState.CUED: // metadata loaded; ready to play
                                    break;
                                case YT.PlayerState.BUFFERING: // 3 video data loading
                                    break;
                                case YT.PlayerState.PLAYING:
                                    //this.ad.classList.remove("pointer-events-none");
                                    break;
                                case YT.PlayerState.PAUSED:
                                    break;
                                case YT.PlayerState.ENDED:
                                    //this.ad.classList.add("pointer-events-none");
                                    break;
                            }
                        },
                        onError: (event: YT.OnErrorEvent) => {
                            console.error("YouTube Player Error: ", event.data);
                            // Reject the promise if there's an error during setup.
                            reject(
                                new Error(`YouTube Player Error: ${event.data}`)
                            );
                        }
                    }
                });
            }
        });
    }
}
